export default {
    review: {
        title: 'Revisione Documento',
        loading: 'Caricamento documento...',
        share: {
            title: 'Condividi documento',
            tabs: {
                invite: 'Invita persone',
                access: 'Persone con accesso',
                link: 'Ottieni link',
            },
            inviteType: {
                receiver: 'Receiver esistenti',
                email: 'Email custom',
                addressbook: 'Address Book',
            },
            fields: {
                recipients: 'Destinatari',
                recipientsPlaceholder: 'Cerca receiver...',
                email: 'Email',
                emailPlaceholder: 'inserisci@email.com',
                contacts: 'Contatti Address Book',
                contactsPlaceholder: 'Cerca contatti...',
                message: 'Messaggio (opzionale)',
                messagePlaceholder: 'Aggiungi un messaggio opzionale...',
            },
            actions: {
                send: 'Invia',
                cancel: 'Annulla',
            },
            noInvites: 'Nessun invito inviato ancora',
            revokeAccess: 'Revoca accesso',
            resend: 'Re-invia',
            revoke: 'Revoca',
            generateLinkDescription: 'Genera un link di condivisione che permette a chiunque di accedere al documento senza autenticazione.',
            linkExpiration: 'Scadenza link',
            expirationOptions: {
                never: 'Mai',
                '1day': '1 giorno',
                '7days': '7 giorni',
                '30days': '30 giorni',
            },
            permissions: {
                view: 'Visualizzazione',
                edit: 'Modifica',
            },
            generateLink: 'Genera link',
            shareLink: 'Link di condivisione',
            copy: 'Copia',
            copied: 'Copiato!',
            linkWarning: 'Chiunque abbia questo link può accedere al documento. Condividilo solo con persone fidate.',
            generateNewLink: 'Genera nuovo link',
        },
        triage: {
            title: 'Triage Documento',
            subtitle: 'Container',
            goToContainerTriage: 'Vai al Triage Documenti',
            resolveWithAI: 'Risolvi con AI',
            tabs: {
                visual: 'Visual',
                raw: 'Raw Data',
            },
            visual: {
                document: 'Documento',
                attributes: 'Attributi Estratti',
                values: 'Valori',
            },
            raw: {
                json: 'JSON',
                highlightDiscrepancies: 'Highlight discrepanze',
            },
            attributes: {
                invoiceNumber: 'Numero Fattura',
                amount: 'Importo',
                currency: 'Valuta',
                issueDate: 'Data Emissione',
                dueDate: 'Data Scadenza',
                shipper: 'Mittente',
                consignee: 'Destinatario',
                containerNumber: 'Numero Container',
                blNumber: 'Numero BL',
            },
            modal: {
                title: 'Risoluzione discrepanze con AI',
                analyzing: 'Sto analizzando e correggendo gli attributi estratti…',
                completed: 'Risoluzione completata',
                allResolved: 'Tutte le discrepanze sono state risolte. Puoi chiudere questa finestra per vedere i risultati aggiornati.',
                close: 'Chiudi',
            },
        },
        status: {
            pending: 'Pending',
            accepted: 'Accepted',
            rejected: 'Rejected',
        },
    },
    history: {
        title: 'Storico Versioni Documento',
        subtitle: 'Documento',
        container: 'Container',
        loading: 'Caricamento storico versioni...',
        notFound: {
            title: 'Documento non trovato',
            message: 'Il documento richiesto non esiste.',
            backToContainer: 'Torna al container',
        },
        versions: {
            count: 'versione',
            versions: 'versioni',
        },
        info: {
            documentType: 'Tipo Documento',
            currentVersion: 'Versione Corrente',
            version: 'Versione',
        },
        empty: {
            title: 'Nessuna versione storica',
            message: 'Questo documento non ha versioni storiche registrate.',
        },
        description: {
            uploadedBy: 'Caricata da',
        },
    },
    triage: {
        title: 'Triage Documento',
        subtitle: 'Container',
        loading: 'Caricamento documento...',
        goToContainerTriage: 'Vai al Triage Container',
        resolveWithAI: 'Risolvi con AI',
        tabs: {
            visual: 'Visual',
            raw: 'Raw Data',
        },
        visual: {
            check: 'Verifica',
            ok: 'OK',
        },
        raw: {
            json: 'JSON',
            highlightDiscrepancies: 'Highlight discrepanze',
        },
        attributes: {
            invoiceNumber: 'Numero Fattura',
            amount: 'Importo',
            currency: 'Valuta',
            issueDate: 'Data Emissione',
            dueDate: 'Data Scadenza',
            shipper: 'Mittente',
            consignee: 'Destinatario',
            containerNumber: 'Numero Container',
            blNumber: 'Numero BL',
        },
        modal: {
            title: 'Risoluzione discrepanze con AI',
            analyzing: 'Sto analizzando e correggendo gli attributi estratti…',
            completed: 'Risoluzione completata',
            allResolved: 'Tutte le discrepanze sono state risolte. Puoi chiudere questa finestra per vedere i risultati aggiornati.',
            close: 'Chiudi',
        },
    },
    drive: {
        title: 'Documenti',
        myDrive: 'My Drive',
        unmappedFiles: 'File Non Associati',
        showEmptyFolders: 'Mostra cartelle vuote',
        search: {
            placeholder: 'Cerca documenti, cartelle, container...',
            noResults: 'Nessun risultato trovato',
            results: 'Risultati ricerca',
            loading: 'Ricerca in corso...',
            section: {
                folders: 'Cartelle',
                documents: 'Documenti',
                containers: 'Container',
            },
        },
        breadcrumb: {
            home: 'My Drive',
        },
        view: {
            card: 'Vista Card',
            list: 'Vista Lista',
        },
        add: {
            button: 'Aggiungi',
            folder: 'Cartella',
            files: 'File',
        },
        folder: {
            container: 'Container',
            customFolder: 'Cartella Personalizzata',
            documentsCount: '{{count}} documento',
            documentsCount_plural: '{{count}} documenti',
            create: 'Crea Cartella',
            open: 'Apri',
            rename: 'Rinomina',
            delete: 'Elimina',
            moveAction: 'Sposta',
            cannotDelete: 'Le cartelle container non possono essere eliminate',
            cannotRename: 'Le cartelle container non possono essere rinominate',
            move: {
                title: 'Sposta Cartella',
                label: 'Seleziona Cartella Destinazione',
                root: 'Root (My Drive)',
                save: 'Sposta',
                cancel: 'Annulla',
            },
            createModal: {
                title: 'Crea Cartella',
                label: 'Nome Cartella',
                parentLabel: 'Cartella Parent (opzionale)',
                save: 'Crea',
                cancel: 'Annulla',
            },
        },
        bulkActions: {
            selectAll: 'Seleziona Tutto',
            deselectAll: 'Deseleziona Tutto',
            selected: '{{count}} selezionato',
            selected_plural: '{{count}} selezionati',
            delete: 'Elimina',
        },
        upload: {
            title: 'Carica Documenti',
            dropZone: 'Trascina file qui o clicca per selezionare',
            success: 'Documenti caricati con successo',
            preview: {
                title: 'Carica {{count}} documento',
                title_plural: 'Carica {{count}} documenti',
                close: 'Chiudi',
                noFiles: 'Nessun file selezionato',
                fileName: 'Nome file',
                documentType: 'Tipo documento',
                unknownDocument: 'Documento sconosciuto',
                addMore: 'Aggiungi altri file',
                cancel: 'Annulla',
                upload: 'Carica',
                uploading: 'Caricamento in corso...',
                viewContent: 'Vedi contenuto',
                status: {
                    pending: 'In attesa',
                    uploading: 'Caricamento...',
                    completed: 'Completato',
                    error: 'Errore',
                },
            },
            error: {
                generic: 'Errore durante il caricamento',
                customFolderRequiresContainer: 'Per caricare file in una cartella personalizzata è necessario selezionare un container',
            },
        },
        document: {
            actions: {
                download: 'Scarica',
                rename: 'Rinomina',
                move: 'Sposta',
                share: 'Condividi',
                delete: 'Elimina',
            },
            rename: {
                title: 'Rinomina Documento',
                label: 'Nome',
                save: 'Salva',
                cancel: 'Annulla',
            },
            move: {
                title: 'Sposta Documento',
                label: 'Seleziona Container',
                save: 'Sposta',
                cancel: 'Annulla',
            },
            share: {
                title: 'Condividi Documento',
                email: 'Email',
                permission: 'Permesso',
                view: 'Visualizzazione',
                edit: 'Modifica',
                comment: 'Commento',
                send: 'Invia',
                cancel: 'Annulla',
            },
            delete: {
                title: 'Elimina Documento',
                message: 'Sei sicuro di voler eliminare questo documento? Questa azione non può essere annullata.',
                confirm: 'Elimina',
                cancel: 'Annulla',
            },
        },
        empty: {
            myDrive: {
                title: 'Nessun documento o cartella',
                description: 'Inizia creando una cartella o caricando documenti per organizzare i tuoi file.',
            },
            folder: {
                title: 'Cartella vuota',
                description: 'Questa cartella non contiene documenti o sottocartelle.',
            },
            search: {
                title: 'Nessun risultato',
                description: 'Prova a modificare i termini di ricerca o i filtri.',
            },
        },
        unmapped: {
            title: 'File Non Associati',
            description: 'File che non sono ancora associati a un container',
            empty: {
                title: 'Nessun file non associato',
                message: 'Tutti i file sono associati a un container.',
            },
            bulkActions: {
                selectAll: 'Seleziona Tutto',
                deselectAll: 'Deseleziona Tutto',
                selectAllLabel: 'Seleziona tutti i file per associarli a un container:',
                associate: 'Associa a Container',
                selected: '{{count}} selezionato',
                selected_plural: '{{count}} selezionati',
            },
            associate: {
                title: 'Associa File a Container',
                label: 'Seleziona Container',
                save: 'Associa',
                cancel: 'Annulla',
            },
        },
        detail: {
            containerInfo: 'Informazioni Container',
            versions: 'Versioni',
            currentVersion: 'Versione Corrente',
            viewVersion: 'Visualizza Versione',
            download: 'Scarica',
            previewNotAvailable: 'Anteprima non disponibile per questo tipo di file',
            notFound: 'Documento non trovato',
            backToDocuments: 'Torna ai Documenti',
            downloadConfirm: {
                title: 'Download File',
                message: 'Questo file non può essere visualizzato nel browser. Vuoi scaricarlo?',
                download: 'Scarica',
                cancel: 'Annulla',
            },
        },
    },
};
